var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop, Mixins } from 'vue-property-decorator';
import LabelControl from '@/common/components/LabelControl.vue';
import { Savable } from '@/common/mixins/Savable';
import PlainTextControl from '@/common/components/PlainTextControl.vue';
import DecimalInputControl from '@/common/components/DecimalInputControl.vue';
var PremisesAreaControl = /** @class */ (function (_super) {
    __extends(PremisesAreaControl, _super);
    function PremisesAreaControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PremisesAreaControl.prototype.rowTotal = function (item) {
        if ((item.totalArea && item.totalArea != 0) && item.steaFundedArea)
            return Math.round((item.steaFundedArea / item.totalArea) * 100);
        return null;
    };
    PremisesAreaControl.prototype.getMin = function (item) {
        if (item) {
            return item.steaFundedArea;
        }
        return null;
    };
    PremisesAreaControl.prototype.getMax = function (item) {
        if (item) {
            return item.totalArea;
        }
        return null;
    };
    Object.defineProperty(PremisesAreaControl.prototype, "items", {
        get: function () {
            return this.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PremisesAreaControl.prototype, "totalTotalArea", {
        get: function () {
            return this.items.reduce(function (a, b) { return a + (b.totalArea || 0); }, 0);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PremisesAreaControl.prototype, "totalSteaFundedArea", {
        get: function () {
            return this.items.reduce(function (a, b) { return a + (b.steaFundedArea || 0); }, 0);
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({ type: String, required: true }),
        __metadata("design:type", String)
    ], PremisesAreaControl.prototype, "title", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], PremisesAreaControl.prototype, "required", void 0);
    __decorate([
        Prop({ type: Array, required: true }),
        __metadata("design:type", Array)
    ], PremisesAreaControl.prototype, "value", void 0);
    __decorate([
        Prop({
            type: Array,
            required: false,
            default: function () { return [
                "InvestmentReport.Finances.Premises.Area.Premises",
                "InvestmentReport.Finances.Premises.Area.Area",
                "InvestmentReport.Finances.Premises.Area.STEAFundedArea",
                "InvestmentReport.Finances.Premises.Area.STEAFundedAreaPercentage"
            ]; }
        }),
        __metadata("design:type", Array)
    ], PremisesAreaControl.prototype, "columnKeys", void 0);
    PremisesAreaControl = __decorate([
        Component({
            name: "PremisesAreaControl",
            components: {
                LabelControl: LabelControl,
                PlainTextControl: PlainTextControl,
                DecimalInputControl: DecimalInputControl
            }
        })
    ], PremisesAreaControl);
    return PremisesAreaControl;
}(Mixins(Savable)));
export default PremisesAreaControl;
